import React from 'react';

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm',
  message = 'Are you sure?',
  confirmText = 'Delete',
  cancelText = 'Cancel',
  type = 'danger',
  wide = false,
}) => {
  if (!isOpen) return null;

  const typeConfig = {
    danger:  { primary: '#dc3545', hover: '#c82333', bg: '#fff5f5', border: '#dc3545', iconBg: '#dc3545' },
    warning: { primary: '#f59e0b', hover: '#d97706', text: '#212529', bg: '#fffbeb', border: '#f59e0b', iconBg: '#f59e0b' },
    info:    { primary: '#0d6efd', hover: '#0b5ed7', bg: '#eff6ff', border: '#0d6efd', iconBg: '#0d6efd' },
  };

  const cfg = typeConfig[type] || typeConfig.danger;
  const textColor = cfg.text || '#fff';

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(2px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 10000, animation: 'confirmOverlayIn 0.15s ease-out',
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: '#fff', borderRadius: '12px', minWidth: '340px',
          maxWidth: wide ? '580px' : '440px', width: wide ? '580px' : undefined,
          boxShadow: '0 20px 60px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.05)',
          overflow: 'hidden', animation: 'confirmDialogIn 0.2s ease-out',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header strip */}
        <div style={{
          background: `linear-gradient(135deg, ${cfg.primary}, ${cfg.hover})`,
          padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '12px',
        }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0,
          }}>
            {type === 'danger' ? '🗑️' : type === 'warning' ? '⚠️' : 'ℹ️'}
          </div>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600, color: '#fff' }}>{title}</h3>
        </div>

        {/* Body */}
        <div style={{ padding: '20px 24px' }}>
          {typeof message === 'string' ? (
            <div style={{ fontSize: '0.93rem', color: '#444', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
              {message}
            </div>
          ) : (
            <div style={{ fontSize: '0.93rem', color: '#444', lineHeight: 1.6 }}>
              {message}
            </div>
          )}
        </div>

        {/* Footer buttons */}
        <div style={{
          padding: '14px 24px', borderTop: '1px solid #f0f0f0',
          display: 'flex', gap: '10px', justifyContent: 'flex-end', backgroundColor: '#fafafa',
        }}>
          <button
            onClick={onCancel}
            style={{
              padding: '9px 20px', backgroundColor: '#fff', color: '#555',
              border: '1px solid #d1d5db', borderRadius: '8px', cursor: 'pointer',
              fontSize: '0.9rem', fontWeight: 500, transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#f3f4f6'; e.target.style.borderColor = '#9ca3af'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.borderColor = '#d1d5db'; }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '9px 20px', backgroundColor: cfg.primary, color: textColor,
              border: 'none', borderRadius: '8px', cursor: 'pointer',
              fontSize: '0.9rem', fontWeight: 600, transition: 'all 0.15s',
              boxShadow: `0 2px 8px ${cfg.primary}40`,
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = cfg.hover; e.target.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = cfg.primary; e.target.style.transform = 'none'; }}
          >
            {confirmText}
          </button>
        </div>
      </div>

      <style>{`
        @keyframes confirmOverlayIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes confirmDialogIn { from { opacity: 0; transform: scale(0.95) translateY(10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
      `}</style>
    </div>
  );
};

export default ConfirmDialog;
